import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import { query, collection, getDocs, where, addDoc } from "firebase/firestore";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { Button, Input } from "reactstrap";

function AdminCreateCouponPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [value, setValue] = useState("");

  const createCoupon = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "discountCodes"), {
        uid: uuidv4(),
        code: code,
        type: type,
        value: value,
        status: "Active",
      });

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE COUPON
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Code
        </p>
        <input
          type="text"
          className="mainInput"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="The coupon's code"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Type
        </p>
        <Input
          type="select"
          className="mainInput"
          value={type}
          onChange={(e) => setType(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The coupon's type
          </option>
          <option value="$">$</option>
          <option value="%">%</option>
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Value
        </p>
        <input
          type="number"
          className="mainInput"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="The coupon's value"
          style={{ marginBottom: "0.5rem" }}
        />
        <Button
          onClick={createCoupon}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={!code || !type || !value}
        >
          CREATE COUPON
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateCouponPage;
